import React from 'react'

const BannerPlaceholder = () => <div className="banner-placeholder" />

export default BannerPlaceholder

